import { Box, IconAI, Inline, Text } from 'braid-design-system';

import { CareerFeedBetaBadge } from './CareerFeedBetaBadge';

import * as styles from './CareerFeedAIHeading.css';

export const CareerFeedAIHeading = ({
  headingText,
  betaBadge,
}: {
  headingText: string;
  betaBadge?: boolean;
}) => (
  <Inline space="xsmall" alignY="center">
    <Text size="large" weight="medium" icon={<IconAI tone="brandAccent" />}>
      <Box component="span" className={styles.gradientText}>
        {headingText}
      </Box>
    </Text>
    {betaBadge && <CareerFeedBetaBadge tone="neutral" />}
  </Inline>
);
